'use strict';
/*
 * Just have a simple pass through so we can use the site preference integration toggles
 * in rvw_integrations_core as well as rvw_autobahn_core
 */
var core = require('core/integrations/siteIntegrationsUtils');

module.exports = core;

